import { useMemo, useState, useRef } from 'react'
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip'
import Settings from '@material-ui/icons/Settings';
import Close from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/core/styles'
import { months } from '../../../../node_modules/moment/moment'
import { useEffect } from 'react'
import { useTranslation } from 'hooks/useTranslation'

const useStyles = makeStyles(theme => {
	return {
		disabled_text_field: {
			color: '#000',
		},
		customTooltip: {
			fontSize: 14,
		},
	}
})

const ErrorPower = () => {
	const { language } = useTranslation()
	const url = 'https://standard1.nbtc.go.th/getattachment/บริการออนไลน์/คัดสำเนาออนไลน์-(1)/SDoC-Online/frequcysdoc.pdf.aspx?lang=th-TH'
	return (
		<div>
			{language === 'en'
				? <>***Frequency or transmission power data is incorrect. Please enter the correct transmission power or unit. You can find more details at <a target="_blank" href={url}>{url}</a> or contact us at email: SDoC@nbtc.go.th</>
				: <>***ข้อมูลกำลังคลื่นความถี่ หรือกำลังส่งไม่ถูกต้อง โปรดกรอกกำลังส่งหรือหน่วยให้ถูกต้อง โดยท่านสามารถศึกษารายละเอียดเพิ่มเติมได้ที่ <a target="_blank" href={url}>{url}</a> หรือสามารถสอบถามข้อมูลเพิ่มเติมได้ที่ email : SDoC@nbtc.go.th</>
			}
		</div>
	)
}



export default function EquipmentCard({
	mountType,
	inputEquipmentState = {
		ProductTypeText: '',
		FrequencyText: '',
		PowerText: '',
		PolicyText: '',
		SelectedPowerUnit: '',
		PolicyText_2: '',
		PolicyText_3: '',
		Flag: '',
	},
	onChangeInputEquipmentState,
	seq,
	equipmentMasterData = {
		typeEquipment: [],
		frequency: [],
		powerUnit: [],
	},
	onDelete,
	index,
	onError = () => { },
}) {
	const classes = useStyles()
	const { t, language } = useTranslation()
	const techTypeMap = t('techType')
	const powerUnitMap = t('powerUnitMap')

	const inputRef = useRef(null);

	const [isError, setIsError] = useState(false)



	const possibleFreq = useMemo(() => {
		const availableFreq = Object.keys(equipmentMasterData.typeEquipment).find(
			x => x.toLowerCase() === inputEquipmentState.ProductTypeText.toLowerCase()
		)

		return equipmentMasterData.typeEquipment[availableFreq] ?? []
	}, [equipmentMasterData, inputEquipmentState])

	const possibleAnnoucement = useMemo(() => {
		if (
			inputEquipmentState.FrequencyText.length === 0 ||
			inputEquipmentState.ProductTypeText.length === 0
		) {

			return []
		}

		const findedMasterItem = equipmentMasterData.frequency.find(f => {
			const isMatchedName =
				f.name.toLowerCase() === inputEquipmentState.FrequencyText.toLowerCase()

			const isMatchedTechType = f.policy.find(
				pf =>
					pf.tech_type.toLowerCase() ===
					inputEquipmentState.ProductTypeText.toLowerCase()
			)

			return isMatchedName && isMatchedTechType
		})

		if (findedMasterItem) {
			const findedPolicy = findedMasterItem.policy.find(
				pf2 =>
					pf2.tech_type.toLowerCase() ===
					inputEquipmentState.ProductTypeText.toLowerCase()
			)

			return findedPolicy.title
		}

		return []
	}, [inputEquipmentState, equipmentMasterData])

	const possibleAnnoucementFlag = useMemo(() => {
		if (
			inputEquipmentState.FrequencyText.length === 0 ||
			inputEquipmentState.ProductTypeText.length === 0
		) {

			return []
		}

		const findedMasterItem = equipmentMasterData.frequency.find(f => {
			const isMatchedName =
				f.name.toLowerCase() === inputEquipmentState.FrequencyText.toLowerCase()

			const isMatchedTechType = f.policy.find(
				pf =>
					pf.tech_type.toLowerCase() ===
					inputEquipmentState.ProductTypeText.toLowerCase()
			)

			return isMatchedName && isMatchedTechType
		})

		if (findedMasterItem) {
			const findedPolicy = findedMasterItem.policy.find(
				pf2 =>
					pf2.tech_type.toLowerCase() ===
					inputEquipmentState.ProductTypeText.toLowerCase()
			)

			return findedPolicy.flag
		}

		return []
	}, [inputEquipmentState, equipmentMasterData])

	const possibleUnits = useMemo(() => {
		if (
			inputEquipmentState.FrequencyText.length === 0 ||
			inputEquipmentState.ProductTypeText.length === 0
		) {
			return []
		}

		const findedMasterItem = equipmentMasterData.frequency.find(f => {
			const isMatchedName =
				f.name.toLowerCase() === inputEquipmentState.FrequencyText.toLowerCase()

			const isMatchedTechType = f.policy.find(
				pf =>
					pf.tech_type.toLowerCase() ===
					inputEquipmentState.ProductTypeText.toLowerCase()
			)

			return isMatchedName && isMatchedTechType
		})

		if (findedMasterItem) {
			const findedPolicy = findedMasterItem.policy.find(
				pf2 =>
					pf2.tech_type.toLowerCase() ===
					inputEquipmentState.ProductTypeText.toLowerCase()
			)

			if (findedPolicy && findedPolicy.power) {
				// Get unique units
				const units = [...new Set(findedPolicy.power.map(p => p.unit))]
				return units
			}
		}

		return []
	}, [inputEquipmentState, equipmentMasterData])

	const filterFrequency = (e, filterFrequencyIndex) => {
		onChangeInputEquipmentState('FrequencyText', '', filterFrequencyIndex)
		onChangeInputEquipmentState('PowerText', '', filterFrequencyIndex)
	}

	const filterFrequency2 = (e, filterFrequencyIndex) => {
		onChangeInputEquipmentState('PowerText', '', filterFrequencyIndex)
	}


	const powerValidationInfo = useMemo(() => {
		const requiredFields = ['FrequencyText', 'ProductTypeText', 'PowerText', 'SelectedPowerUnit']
		if (requiredFields.some(field => inputEquipmentState[field].length === 0)) {
			return { isValid: true, message: '' }
		}

		const freqItem = equipmentMasterData.frequency.find(
			f => f.name.toLowerCase() === inputEquipmentState.FrequencyText.toLowerCase()
		)
		if (!freqItem) return { isValid: true, message: '' }

		const policy = freqItem.policy.find(
			p => p.tech_type.toLowerCase() === inputEquipmentState.ProductTypeText.toLowerCase()
		)
		if (!policy) return { isValid: true, message: '' }

		const userPower = parseFloat(inputEquipmentState.PowerText)
		const userUnit = inputEquipmentState.SelectedPowerUnit.toLowerCase()

		if (isNaN(userPower) || userPower < 0) return { isValid: false, message: t('equipmentCard.invalidNumber') }

		// --- 🔍 Custom rule for dBm ---
		let isValid = false
		let message = ''

		// If no matching unit found in policy, it might be invalid configuration or strict check check needed.
		// For now assuming if unit matches we check, if not we continue.
		// If the user selects a unit that IS in the policy, we validate against that specific rule.

		const matchedPolicyItem = policy.power.find(item => item.unit.toLowerCase() === userUnit)

		if (matchedPolicyItem) {
			const policyValue = parseFloat(matchedPolicyItem.value)
			if (userUnit === 'dbm') {
				// ✅ dBm must match exactly
				isValid = policyValue === userPower
				if (!isValid) message = t('equipmentCard.exactValue')(policyValue)
			} else {
				// ✅ other units can be less than or equal
				isValid = userPower <= policyValue
				if (!isValid) message = t('equipmentCard.maxValue')(policyValue, matchedPolicyItem.unit)
			}
		} else {
			// If unit not found in policy, technically it might be allowed or not, 
			// but based on previous logic it was loop-check. 
			// Previous logic: "isValid" starts false. loops. if unit match -> check value -> if valid break.
			// If unit matches but value invalid -> isValid remains false (unless another entry matches? Unlikely to have duplicate units with diff values).

			// Let's stick to previous logic strictness: if unit not in policy, it's invalid (isValid stays false).
			// But we need a message.
			const allowedUnits = policy.power.map(p => p.unit).join(', ')
			message = t('equipmentCard.invalidUnit')(allowedUnits)
		}

		return { isValid, message }
	}, [equipmentMasterData, inputEquipmentState, language])


	useEffect(() => {
		// console.log(inputEquipmentState.isError);
		setIsError(inputEquipmentState.isError)
	}, [inputEquipmentState.isError])


	// const handleChange = (event) => {
	// 	setSelected(event.target.value === props.value);
	// };

	return (
        <Card className={`border-t-4 border-card_top_border mb-5`}>
            <Grid className="flex flex-col justify-center items-start px-5 pb-3">
				{/* Header */}
				<Grid className="flex flex-row justify-between items-center w-full">
					<Grid className="flex flex-row mt-4 mb-2">
						<Settings style={{ fontSize: 22 }} className="mr-1" />
						<Grid className="font-bold text-sm text-card_header_color">
							{t('equipmentCard.header')} {seq}
						</Grid>
					</Grid>
					{(!mountType || mountType === "ModifyInfo") && (
						<IconButton color="primary" onClick={onDelete}>
							<Close />
						</IconButton>
					)}
				</Grid>
				<Grid className="mt-3 mb-1 w-full">
					<Divider />
				</Grid>
				<Grid className="flex flex-row gap-x-2 w-full justify-center">
					{/* Type of Equipment */}
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('equipmentCard.productType')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<FormControl variant="outlined" fullWidth size="small">
							<Select
								value={inputEquipmentState.ProductTypeText}
								name="ProductTypeText"
								disabled={(mountType && mountType !== "ModifyInfo")}
								onChange={e => {
									onChangeInputEquipmentState(
										e.target.name,
										e.target.value,
										index
									)
									filterFrequency(e, index)
								}}
								className={`${(mountType && mountType !== "ModifyInfo") ? classes.disabled_text_field : ''}`}>
								<MenuItem key={'defaultValueTypeEquipment'} value="" style={{ display: 'none' }} />
								{Object.keys(equipmentMasterData.typeEquipment).map(
									(item, index) => {
										return (
											<MenuItem key={index} value={item}>
												{techTypeMap[item] ?? item}
											</MenuItem>
										)
									}
								)}
							</Select>
						</FormControl>
					</Grid>
				</Grid>

				{/* Frequency and Transmitted Power */}
				<Grid className="flex flex-row gap-x-2 w-full justify-center">
					{/* Frequency */}
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('equipmentCard.frequency')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<FormControl variant="outlined" fullWidth size="small">
							{(!mountType || mountType == "ModifyInfo") ? (
								<Select
									disabled={(mountType && mountType !== "ModifyInfo")}
									name="FrequencyText"
									value={inputEquipmentState.FrequencyText}
									onChange={e => {
										onChangeInputEquipmentState(
											e.target.name,
											e.target.value,
											index
										)
										filterFrequency2(e, index)
									}
									}
									className={`${(mountType && mountType !== "ModifyInfo") ? classes.disabled_text_field : ''}`}>
									<MenuItem key={'defaultValueFrequencyText'} value={''} style={{ display: 'none' }} />

									{possibleFreq.map((item, index) => {
										return (
											<MenuItem key={index} value={item}>
												{item}
											</MenuItem>
										)
									})}
								</Select>
							) : (
								<Grid
									className={`text-xs flex justify-start items-center h-10 rounded w-full border border-gray-300`}>
									<InputBase
										disabled={(mountType && mountType !== "ModifyInfo")}
										name="FrequencyText"
										value={inputEquipmentState.FrequencyText}
										readonly
										className={`${(mountType && mountType !== "ModifyInfo")
											? classes.disabled_text_field
											: ''
											} w-full h-full px-2`}
									/>
								</Grid>

							)}
						</FormControl>
					</Grid>
					{/* Transmitted Power */}
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('equipmentCard.power')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<Tooltip
							title={!powerValidationInfo.isValid ? powerValidationInfo.message : ''}
							placement="bottom"
							arrow
							open={!powerValidationInfo.isValid}
							classes={{ tooltip: classes.customTooltip }}
						>
							<Grid
								className={`text-xs flex justify-start items-center h-10 rounded w-full border ${!powerValidationInfo.isValid ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}>
								<InputBase
									disabled={inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")}
									name="PowerText"
									type="text"
									placeholder={t('equipmentCard.numberOnly')}
									value={inputEquipmentState.PowerText}
									onChange={e => {
										e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/[e-]/ig, '');
										onChangeInputEquipmentState(
											e.target.name,
											e.target.value,
											index
										)
										possibleAnnoucement.map((item, indexs) => {
											onChangeInputEquipmentState(
												indexs > 0 ? "PolicyText_" + (indexs + 1) : 'PolicyText',
												item,
												index
											)
										})
										onChangeInputEquipmentState(
											"Flag",
											possibleAnnoucementFlag,
											index
										)
									}}
									onBlur={e => {
										onChangeInputEquipmentState(
											e.target.name,
											e.target.value,
											index
										)
										possibleAnnoucement.map((item, indexs) => {
											onChangeInputEquipmentState(
												indexs > 0 ? "PolicyText_" + (indexs + 1) : 'PolicyText',
												item,
												index
											)
										})
										onChangeInputEquipmentState(
											"Flag",
											possibleAnnoucementFlag,
											index
										)
									}}
									className={`${inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")
										? classes.disabled_text_field
										: ''
										} w-full h-full px-2`}
								/>
							</Grid>
						</Tooltip>
					</Grid>
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('equipmentCard.unit')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<FormControl variant="outlined" fullWidth size="small">
							<Select
								className={`${inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")
									? classes.disabled_text_field
									: ''
									}`}
								disabled={inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")}
								name="SelectedPowerUnit"
								value={inputEquipmentState.SelectedPowerUnit}
								onChange={e => {
									onChangeInputEquipmentState(
										e.target.name,
										e.target.value,
										index
									)
									possibleAnnoucement.map((item, indexs) => {
										onChangeInputEquipmentState(
											indexs > 0 ? "PolicyText_" + (indexs + 1) : 'PolicyText',
											item,
											index
										)
									})
									onChangeInputEquipmentState(
										"Flag",
										possibleAnnoucementFlag,
										index
									)
								}}
								onBlur={e => {
									onChangeInputEquipmentState(
										e.target.name,
										e.target.value,
										index
									)
									possibleAnnoucement.map((item, indexs) => {
										onChangeInputEquipmentState(
											indexs > 0 ? "PolicyText_" + (indexs + 1) : 'PolicyText',
											item,
											index
										)
									})
									onChangeInputEquipmentState(
										"Flag",
										possibleAnnoucementFlag,
										index
									)
								}}
							>
								<MenuItem key={'defaultValueSelectedPowerUnit'} value={''} style={{ display: 'none' }} />
								{possibleUnits.map((item, index) => {
									return (
										<MenuItem key={item + index} value={item}>
											{powerUnitMap[item] ?? item}
										</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
				{/* Technical Standard and Related Annoucement */}
				<Grid className="flex flex-row gap-x-2 w-full justify-center">
					{/* Related Annoucement */}
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('equipmentCard.relatedAnnouncement')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<FormControl variant="outlined" fullWidth size="small">
							{mountType === 'readOnly' ? (
								// <InputBase
								// 	className={`text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300 px-2 ${mountType ? classes.disabled_text_field : ''
								// 		}`}
								// 	name="PolicyText"
								// 	value={inputEquipmentState.PolicyText}
								// 	disabled={mountType}
								// />
								(<Grid>
                                    {inputEquipmentState.PolicyText ? <Grid key="PolicyText">- {inputEquipmentState.PolicyText}</Grid> : ''}
                                    {inputEquipmentState.PolicyText_2 ? <Grid key="PolicyText_2">- {inputEquipmentState.PolicyText_2}</Grid> : ''}
                                    {inputEquipmentState.PolicyText_3 ? <Grid key="PolicyText_3">- {inputEquipmentState.PolicyText_3}</Grid> : ''}
                                </Grid>)
							) : (
								possibleAnnoucement.map((item, indexs) => {
									return (
										<Grid key={item + indexs}>
											- {item}
										</Grid>
									)
								})
							)}
						</FormControl>
						{/* <FormControl variant="outlined" fullWidth size="small">
							{mountType === 'readOnly' ? (<InputBase
								className={`text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300 px-2 ${mountType ? classes.disabled_text_field : ''
									}`}
								name="PolicyText_2"
								value={inputEquipmentState.PolicyText_2}
								disabled={mountType}
							/>) : (
								<Select
									disabled={inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")}
									name="PolicyText_2"
									value={inputEquipmentState.PolicyText_2}
									onChange={e => {
										onChangeInputEquipmentState(
											e.target.name,
											e.target.value,
											index
										)
									}}
									className={`${inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")
										? classes.disabled_text_field
										: ''
										}`}>
									<MenuItem value={''}>
										โปรดระบุลักษณะทางเทคนิคที่แสดงความสอดคล้อง
									</MenuItem>
									{possibleAnnoucement.map((item, index) => {
										return (
											<MenuItem key={item + index} value={item}>
												{item}
											</MenuItem>
										)
									})}
								</Select>
							)}
						</FormControl>
						<FormControl variant="outlined" fullWidth size="small">
							{mountType === 'readOnly' ? (<InputBase
								className={`text-xs flex justify-start items-center rounded h-10  w-full border border-gray-300 px-2 ${mountType ? classes.disabled_text_field : ''
									}`}
								name="PolicyText_3"
								value={inputEquipmentState.PolicyText_3}
								disabled={mountType}
							/>) : (
								<Select
									disabled={inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")}
									name="PolicyText_3"
									value={inputEquipmentState.PolicyText_3}
									onChange={e => {
										onChangeInputEquipmentState(
											e.target.name,
											e.target.value,
											index
										)
									}}
									className={`${inputEquipmentState.FrequencyText === '' || (mountType && mountType !== "ModifyInfo")
										? classes.disabled_text_field
										: ''
										}`}>
									<MenuItem value={''}>
										โปรดระบุลักษณะทางเทคนิคที่แสดงความสอดคล้อง
									</MenuItem>
									{possibleAnnoucement.map((item, index) => {
										return (
											<MenuItem key={item + index} value={item}>
												{item}
											</MenuItem>
										)
									})}
								</Select>
							)}
						</FormControl> */}
					</Grid>
				</Grid>
				<Grid className=" text-red-500 text-lg">
					{!(mountType && mountType !== "ModifyInfo") &&
						!powerValidationInfo.isValid ? (inputEquipmentState.isError = true) : (inputEquipmentState.isError = false)}
					{!powerValidationInfo.isValid && (<ErrorPower />)}
				</Grid>
			</Grid>
        </Card>
    );
}
